import { all, takeLatest, fork, put, select, call } from 'redux-saga/effects';
import RestaurantsApi from 'libs/api/restaurants';
import UsersApi from 'libs/api/users';
import { SET_CURRENT_RESTAURANT } from 'redux/common/types';

import { setModalData } from '../common/actions';
import routeCodes from 'common/constants/route-codes';
import UIHelper from 'services/UIHelper';
import AuthService from 'services/Auth';

import * as types from './types';

const api = new RestaurantsApi();
const usersApi = new UsersApi();

function* getRestaurants({ payload }) {
  try {
    // const savedRestaurantId = AuthService.getCurrentRestaurant();
    // if (savedRestaurantId) {
    //   const { data: { restaurant } } = yield api.get(savedRestaurantId);
    //   if (restaurant) {
    //     yield put({
    //       type: SET_CURRENT_RESTAURANT,
    //       payload: restaurant,
    //     });
    //     return;
    //   }
    // }
    const { data } = yield api.list(payload);

    // const [firstRestaurant] = data.restaurants || [];
    yield put({
      type: types.RESTAURANTS_GET_SUCCESS,
      payload: data.restaurants,
    });
    // let currentlyRestaurant = firstRestaurant;
    // if (savedRestaurantId) {
    //   const findItem = data.restaurants.find(i => parseInt(i.id) === parseInt(savedRestaurantId));
    //   if (findItem) {
    //     currentlyRestaurant = findItem;
    //   }
    // }
    // yield put({
    //   type: SET_CURRENT_RESTAURANT,
    //   payload: currentlyRestaurant,
    // });
  } catch (e) {
    yield put({
      type: types.RESTAURANTS_GET_FAILURE,
      payload: e?.response,
    });
  }
}

function* getById({ payload }) {
  try {
    const { data } = yield api.get(payload.id);
    yield put({
      type: types.RESTAURANT_BY_ID_GET_SUCCESS,
      payload: data.restaurant,
    });
  } catch (e) {
    yield put({
      type: types.RESTAURANT_BY_ID_GET_FAILURE,
      payload: e?.response,
    });
  }
}

function* createRestaurant({ payload }) {
  try {
    const { formData, afterSuccess } = payload;
    
    // Створюємо ресторан
    const response = yield api.create({
      data: formData,
      headers: { 'Content-Type': 'multipart/Form-data' },
    });

  
    const restaurantId = response.data.restaurant.id;

    yield put({
      type: types.RESTAURANT_CREATE_SUCCESS,
      payload: response.data.restaurant
    });

    // Зберігаємо ресторан як поточний
    yield put({
      type: SET_CURRENT_RESTAURANT,
      payload: response.data.restaurant,
    });

    if (afterSuccess) {
      afterSuccess(response.data.restaurant);
    }
  } catch (e) {
    yield put({
      type: types.RESTAURANT_CREATE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* createOrUpdate({ payload }) {
  try {
    const isSuperAdmin = yield select(
      (state) => state.user.isSuperAdmin,
    );
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const { id, formData, afterSuccess, resetModal } = payload;
    id
      ? yield api.put(id, { data: formData })
      : yield api.create({
          data: formData,
          headers: { 'Content-Type': 'multipart/Form-data' },
        });
    yield put({
      type: types.RESTAURANT_CREATE_OR_UPDATE_SUCCESS,
    });
    // TODO need change, now very high call
    if (!isSuperAdmin) {
      yield put({
        type: types.RESTAURANTS_GET_REQUEST,
        payload: {},
      });
    } else {
      const object = {};
      formData.forEach(function(value, key){
        if (key === 'takeaway' || key === 'delivery' || key === 'reservation' || key === 'disabled') {
          object[key] = value === 'true';
          return;
        }
        object[key] = value;
      });
      yield put({
        type: SET_CURRENT_RESTAURANT,
        payload: {
          ...(currentRestaurant || {}),
          ...object,
        },
      });
    }
    afterSuccess && afterSuccess();
    if (resetModal) {
      yield put(
        setModalData({
          open: false,
          variant: 'primary',
          title: '',
          body: '',
          itemData: {},
        }),
      );
    }
  } catch (e) {
    yield put({
      type: types.RESTAURANT_CREATE_OR_UPDATE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* deleteRestaurant({ payload }) {
  try {
    const { id, history } = payload;
    yield api.destroy(id);
    yield put({
      type: types.RESTAURANT_DELETE_SUCCESS,
    });
    yield put(
      setModalData({
        open: false,
        variant: 'primary',
        title: '',
        body: '',
        itemData: {},
      }),
    );
    UIHelper.showSuccessMessage();
    yield put({
      type: types.RESTAURANTS_GET_REQUEST,
      payload: {},
    });
    history?.push(routeCodes.profile, { showDeleteActivitySuccess: true });
  } catch (e) {
    yield put({
      type: types.RESTAURANT_DELETE_FAILURE,
      payload: e?.response,
    });
  }
}

function* getSelectedRestaurant({ payload }) {
  try {
    const savedRestaurantId = AuthService.getCurrentRestaurant();
    if (savedRestaurantId) {
      const parsed = JSON.parse(savedRestaurantId);
      const { data: { restaurant } } = yield api.get(parsed);
      if (restaurant) {
        yield put({
          type: SET_CURRENT_RESTAURANT,
          payload: restaurant,
        });
      }
    }
    yield put({
      type: types.RESTAURANTS_GET_SELECTED_SUCCESS,
    });
  } catch (e) {
    yield put({
      type: types.RESTAURANTS_GET_SELECTED_FAILURE,
      payload: e?.response,
    });
  }
}

function* bulkCreateUsers({ payload }) {
  try {
    const { users, afterSuccess } = payload;
    const currentRestaurant = yield select(state => state.common.currentRestaurant);
    
    const data = {
      restaurant_id: currentRestaurant?.id || 4414,
      users: users.map(user => ({
        first_name: user.name,
        last_name: user.surname,
        phone: user.phone,
        sms_notification: user.allowBooking,
        email: ''
      }))
    };

    console.log('Sending bulk create request with data:', data);
    yield call([usersApi, 'bulkCreate'], data);

    yield put({
      type: types.USERS_BULK_CREATE_SUCCESS
    });

    if (afterSuccess) {
      afterSuccess();
    }

    UIHelper.showCustomSuccessMessage('Staff members have been successfully added');
  } catch (e) {
    console.log('Full error object:', e);
    console.log('Error response:', e.response);
    console.log('Error data:', e.response?.data);

    // Передаємо дані помилки в action
    yield put({
      type: types.USERS_BULK_CREATE_FAILURE,
      payload: e.response?.data || e.message
    });

    // Викликаємо callback з помилкою
    if (payload.afterError) {
      payload.afterError(e.response?.data);
    }
    UIHelper.showError(e?.response?.data?.message || 'Error creating staff members');
  }
}

function* watchRestaurantListRequest() {
  yield takeLatest(types.RESTAURANTS_GET_REQUEST, getRestaurants);
}

function* watchGetRestaurantRequest() {
  yield takeLatest(types.RESTAURANT_BY_ID_GET_REQUEST, getById);
}

function* watchCreateRestaurantRequest() {
  yield takeLatest(types.RESTAURANT_CREATE_REQUEST, createRestaurant);
}

function* watchCreateOrUpdateRestaurantRequest() {
  yield takeLatest(types.RESTAURANT_CREATE_OR_UPDATE_REQUEST, createOrUpdate);
}
function* watchDeleteRestaurantRequest() {
  yield takeLatest(types.RESTAURANT_DELETE_REQUEST, deleteRestaurant);
}

function* watchGetSelectedRestaurant() {
  yield takeLatest(types.RESTAURANTS_GET_SELECTED_REQUEST, getSelectedRestaurant);
}

function* watchBulkCreateUsers() {
  yield takeLatest(types.USERS_BULK_CREATE_REQUEST, bulkCreateUsers);
}

export default function* restaurantsSaga() {
  yield all([
    fork(watchRestaurantListRequest),
    fork(watchGetRestaurantRequest),
    fork(watchCreateRestaurantRequest),
    fork(watchCreateOrUpdateRestaurantRequest),
    fork(watchDeleteRestaurantRequest),
    fork(watchGetSelectedRestaurant),
    fork(watchBulkCreateUsers),
  ]);
}
